<template>
    <v-dialog v-model="valueInput"
              :fullscreen="$vuetify.breakpoint.xsOnly"
              content-class="_dialog"
              max-width="680">
        <v-card class="text-xs-center app-bg-sand _card">
            <!--CLOSE BTN-->
            <app-svg-icon name="ui/NG_CLOSE"
                          class="_close-btn hidden-sm-and-up"
                          @click="$emit('input', false)"></app-svg-icon>
            <!--CONTENT-->
            <v-card-title class="layout justify-center column pb-0">
                <app-svg-icon name="brand/NG_DELETE"></app-svg-icon>
                <slot name="title">
                    <h2 class="my-3">Delete account</h2>
                </slot>
            </v-card-title>
            <v-card-text class="pt-0">
                <slot name="text">
                    <p class="_card--question text-small">Are you sure you would like to delete your account? This will
                        erase your profile
                        and all
                        information
                        entered.</p>
                </slot>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary"
                       class="elevation-0 v-btn--default"
                       @click="$emit('input', false)">
                    <slot name="cancelButtonText">
                        No, keep my account
                    </slot>
                </v-btn>
                <v-btn class="white--text v-btn--default"
                       color="primary"
                       outline
                       :loading="loading"
                       @click="$emit('confirm')">
                    <slot name="confirmButtonText">
                        Yes, delete my account
                    </slot>
                </v-btn>
            </v-card-actions>
            <!--BACKGROUND-->
            <app-svg-icon name="patterns/NG_Pattern-03"
                          :original="true"
                          class="_card--bg_element hidden-xs-only"></app-svg-icon>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'app-dialog-delete',

    props: {
      value: Boolean,
      loading: Boolean
    },

    computed: {
      valueInput: {
        get: function () {
          return this.value
        },
        set: function (val) {
          this.$emit('input', val)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
    ._close-btn
        width 18px
        height 18px
        color var(--blue)
        position absolute
        z-index 15
        right 16px
        top 16px
    ._card
        position relative
        padding 40px 16px 60px
        min-height 100%
        overflow hidden
        @media (min-width: 600px)
            min-height 410px
            padding 40px 16px 60px
        &--question
            max-width 400px
            margin 16px auto
        &--bg_element
            position absolute
            color var(--green)
            bottom 0
            right -40px
            transform rotate(120deg)
            width 90px
            height 90px
    .v-card__title
        margin-top 100px
        @media (min-width: 600px)
            margin-top 0
        .svg-icon
            color var(--yellow)
            width 60px
            height 60px
    .v-card__actions
        flex-direction column
        padding 0 16px
        @media (min-width: 600px)
            flex-direction row
        .v-btn
            margin 12px
            min-width 230px
</style>



// WEBPACK FOOTER //
// src/components/app-dialog/app-dialog-delete.vue